<template>
    <div id="kv">
        <div class="kvBg" v-if="windowWidth > 768"></div>
        <div class="kvBgm" v-if="windowWidth < 768"> <img src="../assets/kv-bg-m.svg"></div>
        <div class="title" v-if="windowWidth > 768">
            <!--      <img src="../assets/kv-title.svg" alt="網路投保好禮3重抽"   v-if="windowWidth=680">-->
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onUnmounted } from "vue";

const windowWidth = ref(window.innerWidth);

const handleResize = () => {
    windowWidth.value = window.innerWidth;
};

onBeforeMount(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
});

onMounted(() => {
    handleResize();
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});
</script>

<style lang="scss">
#kv {
    margin-top: 95px;
  background:url("../assets/kv-bg.svg") center top / contain repeat-x;
  background-size: 1920px;
  overflow: hidden;
    background-size: 1920px;
    @media screen and (max-width: 768px) {
        margin-top: 95px;
        height: 100%;
        background-size: cover;
    }

    .bg{position:relative;top:0;z-index: 10;}
    .title{
        position: relative;
        background: url("../assets/kv-title.svg") center center / cover no-repeat;
        height: 675px;
        max-width: 1100px;
        margin: auto;
    }
}
</style>